import React from 'react';
import Contato from 'assets/images/contato.svg';
import { openSupportChat } from 'services/support_chat';
import { Container } from './styles';

const ConlicitasegContact: React.FC = () => {
  return (
    <div className="page-container">
      <Container>
        <div className="row">
          <div className="col-md-12">
            <div
              className="card d-flex mx-auto justify-content-center align-items-center p-5 mt-5"
              style={{ width: '455px' }}
            >
              <img
                className="card-img-top mt-5"
                src={Contato}
                alt="Imagem contato"
                style={{ width: '185px' }}
              />
              <div className="card-body">
                <h5 className="card-title card-title-text">
                  Entre em contato para
                  <br />
                  falar sobre sua cotação
                </h5>
                <p className="card-text-subtitle">
                  Para conversar sobre sua garantia envie uma mensagem aos nossos consultores ou nos
                  contate pelo telefone <strong>(11) 3789-9117</strong>
                </p>
                <button
                  type="button"
                  className="btn btn-primary text-center"
                  onClick={() => openSupportChat()}
                >
                  Solicitar atendimento
                </button>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
export { ConlicitasegContact };
